import { useEffect, useRef, useState } from 'react';

/* Moves a value toward target at a constant speed (full travel in `seconds`), like a shade motor */
export const useGlide = (target, seconds = 2.2, enabled = true) => {
  const [value, setValue] = useState(target);
  const st = useRef({ value: target, raf: 0, last: 0 });

  useEffect(() => {
    cancelAnimationFrame(st.current.raf);
    st.current.last = 0;
    if (!enabled) {
      st.current.value = target;
      setValue(target);
      return undefined;
    }
    const step = (ts) => {
      const s = st.current;
      const dt = s.last ? (ts - s.last) / 1000 : 0;
      s.last = ts;
      const diff = target - s.value;
      const maxDelta = dt / seconds;
      if (Math.abs(diff) <= maxDelta) {
        s.value = target;
        setValue(target);
        return;
      }
      s.value += Math.sign(diff) * maxDelta;
      setValue(s.value);
      s.raf = requestAnimationFrame(step);
    };
    st.current.raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(st.current.raf);
  }, [target, seconds, enabled]);

  return value;
};

export default useGlide;
